// @flow
import * as React from 'react';

import UserSchoolsContainer from './UserSchoolsContainer.jsx';
import UserSchoolsForm from './UserSchoolsForm.jsx';

class UserSchools extends React.Component<*, *> {
  render() {
    return <UserSchoolsContainer>{props => <UserSchoolsForm {...props} />}</UserSchoolsContainer>;
  }
}

export default UserSchools;
